import React from 'react';
import { FaSearch, FaPhoneAlt, FaHeart, FaStethoscope } from 'react-icons/fa'; 

const steps = [
  {
    icon: <FaSearch className="text-orange-500 text-3xl" />,
    title: "Search Pet",
    description: "Adopt a dog or cat who's right for you. Simply enter your city above to start your search.",
  },
  {
    icon: <FaPhoneAlt className="text-orange-500 text-3xl" />,
    title: "Connect",
    description: "Once you find a pet, click 'show number' to get contact info for their pet parent or rescue. Contact them to learn more about how to meet and adopt the pet.",
  },
  {
    icon: <FaHeart className="text-orange-500 text-3xl" />,
    title: "AdoptLove",
    description: "The rescue or pet parents will walk you through their adoption process. Prepare your home for the arrival of your fur baby to help them adjust to their new family.",
  },
  {
    icon: <FaStethoscope className="text-orange-500 text-3xl" />,
    title: "Free Vet Consultation",
    description: "ThePetNest will help your pet to settle down in its new home. Once you complete the adoption journey, reach out to us for free vet consultation.",
  },
];

const PetAdoptionJourney = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-8">
          Your Pet Adoption Journey With Adopt a Pet
        </h2>

        <div className="flex flex-col lg:flex-row gap-12 items-center">
          <div className="flex-1 lg:max-w-lg">
            <img
              src="//dm6g3jbka53hp.cloudfront.net/static-images/adopt-me-pet-02032021.jpg"
              alt="Adopt a Pet"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>

          <div className="flex-1 space-y-8 text-center lg:text-left">
            {steps.map((step, index) => (
              <div key={index} className="flex items-center justify-center lg:justify-start gap-4">
                {step.icon}
                <div>
                  <h3 className="text-2xl font-semibold text-gray-800">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetAdoptionJourney;
